module.exports = __webpack_public_path__ + "img/brands.40a8f764.svg";